import { ZIP_QUERY_PARAMS_KEYS } from '@src/quince-site-common/src/hooks/zipcode/context/zipcode.context.provider'
import { ServerSideFeatureFlags } from '@src/server-side/feature-flags/feature-flag.types'
import { IZipCodeInfo } from '@src/server-side/get-server-side-props'

export const _BFF_API_VERSIONS = {
  v1: 'v1',
  v2: 'v2',
  v3: 'v3',
} as const

export const getIsClpPersonalisationActive = (serverSideFeatureFlags: ServerSideFeatureFlags) => {
  return (
    serverSideFeatureFlags.featureFlagType === 'collection' &&
    serverSideFeatureFlags.clpPersonalisationExperimentBucket === 'show'
  )
}

export const setZipCodeSearchParams = (zipCodeInfo: IZipCodeInfo | null, searchParams?: URLSearchParams) => {
  const headers: Record<string, string> = {}
  if (!searchParams) {
    searchParams = new URLSearchParams()
  }
  if (!zipCodeInfo) {
    return { updatedSearchParams: searchParams, headersZipCode: headers }
  }
  if (zipCodeInfo.zipCode) {
    searchParams.set(ZIP_QUERY_PARAMS_KEYS.ZIP_CODE, zipCodeInfo.zipCode)
  }
  if (zipCodeInfo.userEnteredZipCode) {
    searchParams.set(ZIP_QUERY_PARAMS_KEYS.USER_ENTERED_ZIP_CODE, zipCodeInfo.userEnteredZipCode)
  }
  if (zipCodeInfo.ipAddress) {
    headers[ZIP_QUERY_PARAMS_KEYS.IP_ADDRESS] = zipCodeInfo.ipAddress
  }
  if (zipCodeInfo.newIpAddress) {
    headers[ZIP_QUERY_PARAMS_KEYS.NEW_IP_ADDRESS] = zipCodeInfo.newIpAddress
  }
  return { updatedSearchParams: searchParams, headersZipCode: headers }
}
